import { render, staticRenderFns } from "./capability-label.vue?vue&type=template&id=112f4bb2&scoped=true&"
import script from "./capability-label.vue?vue&type=script&lang=js&"
export * from "./capability-label.vue?vue&type=script&lang=js&"
import style0 from "./capability-label.vue?vue&type=style&index=0&id=112f4bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f4bb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('112f4bb2')) {
      api.createRecord('112f4bb2', component.options)
    } else {
      api.reload('112f4bb2', component.options)
    }
    module.hot.accept("./capability-label.vue?vue&type=template&id=112f4bb2&scoped=true&", function () {
      api.rerender('112f4bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/capability-label.vue"
export default component.exports